var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "color-modal-content-desc text-uppercase font-16 row" },
    [
      _c("div", { staticClass: "col-11" }, [
        _vm.getSelectedProduct.styleName != null &&
        _vm.getSelectedProduct.styleName != undefined
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-center heading-2 black font-weight-bold"
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.getSelectedProduct.styleName) +
                    "\n    "
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.getSelectedProduct.styleNumber != null &&
        _vm.getSelectedProduct.styleNumber != undefined
          ? _c("div", { staticClass: "d-flex justify-content-center  mt-2" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$resourceString[
                      "myProject.Project.EditPage.Item.ColorPreviewModal.Style.Label"
                    ]
                  ) +
                  " : " +
                  _vm._s(_vm.getSelectedProduct.styleNumber) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.getSelectedProduct.productActualSize != null &&
        _vm.getSelectedProduct.productActualSize != undefined
          ? _c("div", { staticClass: "d-flex justify-content-center black" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.$resourceString[
                      "myProject.Project.EditPage.Item.ColorPreviewModal.Size.Label"
                    ]
                  ) +
                  ": " +
                  _vm._s(_vm.getSelectedProduct.productActualSize) +
                  "\n    "
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.color.colorNumber != null && _vm.color.colorNumber != undefined
          ? _c(
              "div",
              { staticClass: "d-flex justify-content-center black mt-1" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$resourceString[
                        "myProject.Project.EditPage.Item.ColorPreviewModal.Color.Label"
                      ]
                    ) +
                    ": " +
                    _vm._s(_vm.color.colorName + " " + _vm.color.colorNumber) +
                    "\n    "
                )
              ]
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.color.colorVariationLevel &&
      (_vm.color.colorVariationLevel.code != null ||
        _vm.color.colorVariationLevel.description != null)
        ? _c("div", { staticClass: "col-12 " }, [
            _c(
              "div",
              { staticClass: "d-flex justify-content-center  black mt-1" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$resourceString[
                        "myProject.Project.EditPage.Item.ColorPreviewModal.ColorVariationRating.Label"
                      ]
                    ) +
                    ":\n      " +
                    _vm._s(
                      _vm.color.colorVariationLevel.code +
                        " - " +
                        _vm.color.colorVariationLevel.description
                    ) +
                    "\n    "
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-12 create-project-button mt-2" }, [
        _c(
          "button",
          {
            staticClass: "m-4 btn btn-primary",
            attrs: { type: "button", disabled: _vm.OrderSampleEnabled },
            on: {
              click: function($event) {
                return _vm.addItemToCart(_vm.color.colorNumber)
              }
            }
          },
          [
            _c("span", {
              staticClass: "png-icon png-icon-icons-glyph--ko-my-basket mr-2"
            }),
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm.$resourceString[
                    "myProject.Project.EditPage.Item.ColorPreviewModal.AddToBasketSample.Label"
                  ]
                ) +
                "\n    "
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }